import script from "./checkbox-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox-item.vue?vue&type=script&setup=true&lang=ts"

import "./checkbox-item.vue?vue&type=style&index=0&id=099d9ccc&lang=scss"

const __exports__ = script;

export default __exports__